import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/base/ScrollToTopButton';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesSection from './components/CategoriesSection';
import PopularArticlesSection from './components/PopularArticlesSection';
import FAQSection from './components/FAQSection';
import DownloadCTASection from './components/DownloadCTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoriesSection />
        <PopularArticlesSection />
        <FAQSection />
        <DownloadCTASection />
      </main>
      <Footer />
      <ScrollToTopButton />
    </>
  );
}